const t = {
  toView(r) {
    return JSON.stringify(r);
  },
  fromView(r) {
    return typeof r != "string" ? r : JSON.parse(r);
  }
};
export {
  t as JsonValueConverter
};
